// 请假
export default [
  {
    path: '/full/leave/index',
    pathType: 'keep',
    name: 'PageLeaveIndex',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveIndex'
      ),
    meta: { modular: 2, title: '请假', info: '请假——首页' }
  },
  {
    path: '/full/leave/setting',
    pathType: 'keep',
    name: 'PageLeaveSetting',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveSetting'
      ),
    meta: { modular: 2, title: '设置', info: '请假——设置页' }
  },
  {
    path: '/leave/enteranceGuard',
    name: 'PageLeaveEntranceGuard',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveEntranceGuard'
      ),
    meta: { modular: 2, title: '到离校门禁', info: '请假——到离校门禁' }
  },
  {
    path: '/leave/applyTime',
    name: 'PageLeaveTime',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveTime'
      ),
    meta: {
      modular: 2,
      title: '家长发起请假时间',
      info: '请假——家长发起请假时间'
    }
  },
  {
    path: '/leave/permitTime',
    name: 'PageLeavePermitTime',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeavePermitTime'
      ),
    meta: { modular: 2, title: '设置', info: '请假——设置允许请假时间' }
  },
  {
    path: '/leave/chooseDeverice',
    name: 'PageLeaveChooseDeverice',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveChooseDeverice'
      ),
    meta: { modular: 2, title: '选择设备', info: '请假——选择到离校设备' }
  },
  {
    path: '/leave/cancel',
    name: 'PageLeaveCancel',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveCancel'
      ),
    meta: { modular: 2, title: '撤销原因', info: '请假——撤销原因' }
  },
  {
    path: '/full/leave/apply',
    pathType: 'keep',
    name: 'PageLeaveApply',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveApply'
      ),
    meta: {
      modular: 2,
      title: '发起请假',
      info: '请假——发起请假',
      keepAlive: true
    }
  },
  {
    path: '/full/leave/applyBatch',
    pathType: 'keep',
    name: 'PageLeaveApplyBatch',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveApplyBatch'
      ),
    meta: {
      modular: 2,
      title: '发起请假',
      info: '请假——发起请假',
      keepAlive: true
    }
  },
  {
    path: '/full/leave/detail',
    pathType: 'keep',
    name: 'PageLeaveDetail',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveDetail'
      ),
    meta: { modular: 2, title: '请假详情', info: '请假——详情' }
  },
  {
    path: '/full/leave/history',
    pathType: 'keep',
    name: 'PageLeaveHistory',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveHistory'
      ),
    meta: { modular: 2, title: '请假记录', info: '请假——记录' }
  },
  {
    path: '/leave/list',
    name: 'PageLeaveList',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveList'
      ),
    meta: { modular: 2, title: '修改或撤销请假', info: '请假——修改或撤销请假' }
  },
  {
    path: '/full/leave/stastics',
    pathType: 'keep',
    name: 'PageLeaveStastics',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveStastics'
      ),
    meta: {
      modular: 2,
      title: '学生请假',
      info: '请假——学生请假统计列表',
      keepAlive: true
    }
  },
  {
    path: '/leave/notice',
    name: 'PageLeaveNotice',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveNotice'
      ),
    meta: { modular: 2, title: '通知设置', info: '请假——通知设置' }
  },
  {
    path: '/leave/noticeDetail',
    name: 'PageLeaveNoticeDetail',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveNoticeDetail'
      ),
    meta: { modular: 2, title: '通知设置', info: '请假——通知设置详情' }
  },
  {
    path: '/leave/reports',
    name: 'PageLeaveReports',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveReports'
      ),
    meta: { modular: 2, title: '请假记录报表', info: '请假——报表' }
  },
  {
    path: '/leave/apply/timeaxis',
    name: 'PageApplyTimeAxis',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageApplyTimeAxis'
      ),
    meta: { modular: 2, title: '请假明细', info: '请假——明细' }
  },
  {
    path: '/leave/applyBatch/timeaxis',
    name: 'PageApplyTimeAxis',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageApplyTimeAxis'
      ),
    meta: { modular: 2, title: '请假明细', info: '请假——明细' }
  },
  {
    path: '/full/leave/entrance/list',
    pathType: 'keep',
    name: 'PageLeaveEntranceList',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveEntranceList'
      ),
    meta: { modular: 2, title: '通行权限', info: '请假——通行权限' }
  },
  {
    path: '/leave/back',
    name: 'PageLeaveBack',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveBack'
      ),
    meta: { modular: 2, title: '返校证明', info: '请假——返校证明' }
  },
  {
    path: '/leave/backdetail',
    name: 'PageLeaveBackDetail',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveBackDetail'
      ),
    meta: { modular: 2, title: '返校证明', info: '请假——返校证明' }
  },
  {
    path: '/leave/approval',
    name: 'PageLeaveApproval',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveApproval'
      ),
    meta: { modular: 2, title: '授权审批表单', info: '请假——授权审批表单' }
  },
  {
    path: '/leave/approvalDevice',
    name: 'PageLeaveApprovalDevice',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveApprovalDevice'
      ),
    meta: {
      modular: 2,
      title: '选择可通行设备',
      info: '请假——审批选择可通行设备'
    }
  },
  {
    path: '/full/leave/type',
    pathType: 'keep',
    name: 'PageLeaveType',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveType'
      ),
    meta: {
      modular: 2,
      title: '请假类型',
      info: '请假——请假类型'
    }
  },
  {
    path: '/full/leave/error',
    pathType: 'keep',
    name: 'PageLeaveError',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveError'
      ),
    meta: { modular: 2, title: '请假', info: '请假——请假失败' }
  },
  // 请假灰度
  {
    path: '/gray/leave/error',
    pathType: 'keep',
    name: 'GrayPageLeaveError',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveError'
      ),
    meta: { modular: 2, title: '请假', info: '请假——请假失败' }
  },
  {
    path: '/gray/leave/apply',
    pathType: 'keep',
    name: 'GrayPageLeaveApply',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveApply'
      ),
    meta: {
      modular: 2,
      title: '发起请假',
      keepAlive: true,
      info: '请假——发起请假'
    }
  },
  {
    path: '/gray/leave/applyBatch',
    pathType: 'keep',
    name: 'PageLeaveApplyBatch',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveApplyBatch'
      ),
    meta: {
      modular: 2,
      title: '发起请假',
      info: '请假——发起请假',
      keepAlive: true
    }
  },
  {
    path: '/gray/leave/index',
    pathType: 'keep',
    name: 'GrayPageLeaveIndex',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveIndex'
      ),
    meta: { modular: 2, title: '请假', info: '请假——首页' }
  },
  {
    path: '/gray/leave/detail',
    pathType: 'keep',
    name: 'GrayPageLeaveDetail',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveDetail'
      ),
    meta: { modular: 2, title: '请假详情', info: '请假——详情' }
  },
  {
    path: '/gray/leave/setting',
    pathType: 'keep',
    name: 'GrayPageLeaveSetting',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveSetting'
      ),
    meta: { modular: 2, title: '设置', info: '请假——设置页' }
  },
  {
    path: '/gray/leave/type',
    pathType: 'keep',
    name: 'GrayPageLeaveType',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveType'
      ),
    meta: {
      modular: 2,
      title: '请假类型',
      info: '请假——请假类型'
    }
  },
  {
    path: '/full/leave/subtype',
    pathType: 'keep',
    name: 'PageLeaveSubType',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveSubType'
      ),
    meta: {
      modular: 2,
      title: '请假类型',
      info: '请假——请假类型'
    }
  },
  {
    path: '/gray/leave/subtype',
    pathType: 'keep',
    name: 'GrayPageLeaveSubType',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveSubType'
      ),
    meta: {
      modular: 2,
      title: '请假类型',
      info: '请假——请假类型'
    }
  },
  {
    path: '/full/leave/entranceDevice',
    pathType: 'keep',
    name: 'PageLeaveEntranceDevice',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/PageLeaveEntranceDevice'
      ),
    meta: {
      modular: 2,
      title: '学生可进出校设备',
      info: '请假——学生可进出校设备'
    }
  },
  {
    path: '/gray/leave/entranceDevice',
    pathType: 'keep',
    name: 'GrayPageLeaveEntranceDevice',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveEntranceDevice'
      ),
    meta: {
      modular: 2,
      title: '学生可进出校设备',
      info: '请假——学生可进出校设备'
    }
  },
  {
    path: '/gray/leave/history',
    pathType: 'keep',
    name: 'PageLeaveHistory',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveHistory'
      ),
    meta: { modular: 2, title: '请假记录', info: '请假——记录' }
  },
  {
    path: '/gray/leave/stastics',
    pathType: 'keep',
    name: 'PageLeaveStastics',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveStastics'
      ),
    meta: {
      modular: 2,
      title: '学生请假',
      info: '请假——学生请假统计列表',
      keepAlive: true
    }
  },
  {
    path: '/gray/leave/entrance/list',
    pathType: 'keep',
    name: 'GrayPageLeaveEntranceList',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/leave/gray/PageLeaveEntranceList'
      ),
    meta: { modular: 2, title: '通行权限', info: '请假——通行权限' }
  }
]
